import { render, staticRenderFns } from "./SelectCardType.vue?vue&type=template&id=454c96d7&scoped=true"
import script from "./SelectCardType.vue?vue&type=script&lang=js"
export * from "./SelectCardType.vue?vue&type=script&lang=js"
import style0 from "./SelectCardType.vue?vue&type=style&index=0&id=454c96d7&prod&lang=scss&scoped=true"
import style1 from "./SelectCardType.vue?vue&type=style&index=1&id=454c96d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c96d7",
  null
  
)

export default component.exports